export default {
  state: {
    RnInfo: {
      // device: 'android',
      // language: 'zh_CN',
      // token: 'e0486d9497204044817909bd8f16d568'
    },
    headerInfo: '',
    buyProInfo: '', // 用来保存购买的产品信息
    prodClass: '', // 用来保存产品类型
    proInfo: '', // 产品信息录入页信息
    proInfoDetails: '' // 产品详情
  },
  getters: {
    RnInfo ({ RnInfo }) {
      return RnInfo
    },
    buyProInfo ({ buyProInfo }) {
      return buyProInfo
    },
    proInfo ({ proInfo }) {
      return proInfo
    },
    proInfoDetails ({ proInfoDetails }) {
      return proInfoDetails
    },
    headerInfo ({ headerInfo }) {
      return headerInfo
    },
    prodClass ({ prodClass }) {
      return prodClass
    }
  },
  mutations: {
    RnInfo (state, newValue) {
      state.RnInfo = newValue
    },
    buyProInfo (state, newValue) {
      state.buyProInfo = newValue
    },
    proInfo (state, newValue) {
      state.proInfo = newValue
    },
    proInfoDetails (state, newValue) {
      state.proInfoDetails = newValue
    },
    headerInfo (state, newValue) {
      state.headerInfo = newValue
    },
    prodClass (state, newValue) {
      state.prodClass = newValue
    }
  }
}
